import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// The Woodsy Craft Co. (b_atnn44mpxf, advertiser -7828252857858171118).
// Real numbers from ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS
// (lifetime totals; 23-month tenure from Oct 2024). NEW_AND_RETURNING with
// separate campaign budgets. The smallest and lumpiest of the three new brands —
// 17 lifetime acquisitions, five zero-conversion months in the year shown — but
// the highest first-year ROAS at 6.1x, carried by a single Oct 2025 customer
// worth $2,613 to date. Monthly series (complete months Aug 2025 – Jul 2026) +
// partial Aug 2026 live in realBrandData.ts.
//
// `budget` is the platform's standing budget recommendation, not a reported
// figure: reported budgets stop after Apr 2026 for this advertiser.
// `spendingMode` is not in the source data and is set here only so the growth-mode
// module has a defined default.
export const advWoodsyCraft: FaireAdvertiserProfileEntity = {
  token: "adv_woodsy_craft",
  type: "advertiserProfile",
  archetype: "floor-budget-tiny-results",
  displayName: "The Woodsy Craft Co.",
  brandToken: "b_atnn44mpxf",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 23,
  budget: {
    totalBudgetDollars: 410,
    spendingMode: "MODERATE",
    nextRenewsAtDate: "2026-09-01",
    nextBillsAtDate: "2026-09-04",
  },
  overview: {
    numCustomersAcquired: 17,
    numReorderConversions: 14,
    numTotalConversions: 31,
    totalAdsSalesDollars: 14587,
    newCustomerAdsSalesDollars: 11435,
    reorderAdsSalesDollars: 3152,
    totalAdsSpendDollars: 2216,
    newCustomerAdsSpendDollars: 1874,
    reorderAdsSpendDollars: 343,
    newCustomerBestEstimateFirstYearRoas: 6.1,
    reorderRoas: 9.2,
    combinedFirstYearRoas: 6.58,
    // MANAGER_METRICS_BRAND_ORDERS: 30 orders on the new-customer campaign
    // (from 17 acquired customers) and 16 on the reorder campaign.
    numNewCustomerAdsOrders: 30,
    numReorderAdsOrders: 16,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 310,
      maxRecommendedBudgetDollars: 620,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 100,
      maxRecommendedBudgetDollars: 200,
    },
  },
  campaignTokens: ["camp_wc_new", "camp_wc_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
